
<div class="whats-float">
    <a href="https://wa.me/+919109911372"
       target="_blank">
        <i class="fa fa-whatsapp"></i><span>WhatsApp<br><small>+91 91099 11372</small></span>
    </a>
</div>
